export default {
    async display(parent, component, context, title, callback, options={}){
        let form = parent.$createElement(component, {
            key: Math.floor(Math.random() * Math.floor(10000)),
            props: context,
        });
        let confirmButtonText = '';
        let cancelButtonText = '';
        if(options.confirmButtonText !== undefined){
            confirmButtonText = options.confirmButtonText;
        }else if(options.confirmButtonTextStored){
            confirmButtonText = parent.$store.getters['fundation/getVerbose'](options.confirmButtonTextStored);
        }else{
            confirmButtonText = parent.$store.getters['fundation/getVerbose']('modal_form_confirm_button_text');
        }
        if(options.cancelButtonText !== undefined){
            cancelButtonText = options.cancelButtonText;
        }else if(options.cancelButtonTextStored){
            cancelButtonText = parent.$store.getters['fundation/getVerbose'](options.cancelButtonTextStored);
        }else{
            cancelButtonText = parent.$store.getters['fundation/getVerbose']('cancel');
        }
        try{
            await parent.$msgbox({
                title: title,
                showCancelButton: options.showCancelButton !== undefined ? options.showCancelButton : true,
                showConfirmButton: options.showConfirmButton !== undefined? options.showConfirmButton : true,
                closeOnClickModal: options.closeOnClickModal !== undefined? options.closeOnClickModal : false,
                confirmButtonText: confirmButtonText,
                cancelButtonText: cancelButtonText,
                customClass: context.customClassName || '',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = parent.$store.getters['fundation/getVerbose']('modal_form_loading');
                        try{
                            if(form.componentInstance.$refs.form.rules !== undefined){
                                form.componentInstance.$refs.form.validate((valid) => {
                                    if (valid) {
                                        callback(form.componentInstance.form).then((response) => {
                                            instance.confirmButtonLoading = false;
                                            instance.confirmButtonText = parent.$store.getters['fundation/getVerbose']('modal_form_confirm_button_text');
                                            done();
                                        });
                                    } else {
                                        instance.confirmButtonLoading = false;
                                        instance.confirmButtonText = parent.$store.getters['fundation/getVerbose']('modal_form_confirm_button_text');
                                    }
                                });
                            }else{
                                callback(form.componentInstance.form).then((response) => {
                                    instance.confirmButtonLoading = false;
                                    instance.confirmButtonText = parent.$store.getters['fundation/getVerbose']('modal_form_confirm_button_text');
                                    done();
                                });
                            }

                        }catch(e){
                            console.error(e);
                            instance.confirmButtonLoading = false;
                            instance.confirmButtonText = parent.$store.getters['fundation/getVerbose']('modal_form_confirm_button_text');
                        }
                    } else {
                        done();
                        instance.confirmButtonLoading = false;
                        instance.confirmButtonText = parent.$store.getters['fundation/getVerbose']('modal_form_confirm_button_text');
                    }
                },
                message: form,
            });
        }
        catch(exception){
            return Promise.reject(exception);
        }
    },
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/fundation-app-vuejs/src/components/partials/modal-form.js
// module id = rUoH
// module chunks = 0